<script>
  import FacebookFeed from './FacebookFeed.svelte'

  let feedWidth;
  let feedHeight;

  // yeah that's right, I did it. JT 6/2/20
  function scrollToForm() {
    const form =
      document.getElementsByClassName("l-casey-form")[0].getBoundingClientRect()
        .top + window.scrollY;
    window.scrollTo({
      top: form,
      behavior: "smooth",
    });
  }
</script>

<style>
  .l-media {
    padding: 100px 60px;
    background: #1b22251c;
    /* box-sizing: border-box; */
  }

  .media {
    height: 960px;
    display: flex;
    max-width: 1210px;
    margin: 0 auto;
    padding: 56px 0 0 56px;
    background: #fff;
    /* box-sizing: border-box; */
  }

  .l-press {
    width: calc(50% - 28px);
    box-sizing: border-box;
    /* border-right: 1px solid #1B22251C; */
  }

  .l-press-feature:first-child {
    padding: 0 56px 70px 0;
    box-sizing: border-box;
    border-right: 1px solid #1b22251c;
  }

  .l-press-feature:nth-child(2) {
    /* padding: 0 56px; */
    padding: 70px 56px 0 0;
    border-top: 1px solid #1b22251c;
    border-right: 1px solid #1b22251c;
  }

  .press-feature-photo {
    height: 256px;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .press-feature-desc {
    display: flex;
    margin-top: 40px;
  }

  .press-feature-desc p {
    font-size: 15px;
    line-height: 1.4;
    margin-right: 20px;
  }

  .press-feature-desc a {
    font-size: 18px;
    line-height: 1.4;
    font-weight: 600;
    color: #93d477;
    text-transform: uppercase;
    cursor: pointer;
    letter-spacing: 1px;
  }

  .press-feature-desc span {
    font-size: 18px;
    line-height: 1.4;
    font-weight: 600;
    color: #93d477;
    text-transform: uppercase;
    cursor: pointer;
    letter-spacing: 1px;
  }

  .l-feed {
    width: 50%;
    margin: 0 auto;
    padding: 0 56px;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    /* border-left: 1px solid #1B22251C; */
  }

  @media (max-width: 1252px) {
    .press-feature-desc p {
      margin-right: 20px;
    }

    .press-feature-desc a {
      font-size: 16px;
    }
  }

  @media (max-width: 1210px) {
    .media {
      max-width: 100%;
      /* box-sizing: border-box; */
    }

    .l-feed {
      padding: 0 56px;
    }
  }

  @media (max-width: 925px) {
    .media {
      display: block;
      padding: 40px;
      height: auto;
    }

    .l-press,
    .l-feed {
      width: 100%;
    }

    .l-feed {
      height: 848px;
    }

    .l-press-feature {
      padding: 50px 0px !important;
    }

    .press-feature-desc {
      flex-wrap: wrap;
    }

    .l-press-feature:first-child {
      padding: 0 56px 70px 0;
      box-sizing: border-box;
      border-right: none;
    }

    .l-press-feature:nth-child(2) {
      border-right: none;
    }

    .press-feature-desc .button {
      margin-top: 30px;
    }

    .press-feature-desc p {
      margin-right: 0px;
    }
  }

  @media (max-width: 720px) {
    .press-feature-desc a {
      margin-top: 20px;
    }
  }

  @media (max-width: 640px) {
    .l-feed {
      display: none;
    }
  }

  @media (max-width: 450px) {
    .l-media {
      padding: 0px 0px 100px 0px;
      background: #1b22251c;
      /* box-sizing: border-box; */
    }
  }
</style>

<section class="l-media">
  <div class="media">
    <div class="l-press">
      <div class="l-press-feature">
        <div
          class="press-feature-photo"
          style="background-image: url('images/social-media-caseynew1-img.jpg')" />
        <div class="press-feature-desc top">
          <div class="paragraph">
            <p>
              Casey Crawford’s media kit includes photos and a bio. Click here
              to download it.
            </p>
          </div>
          <div class="button">
            <!-- Mediakit updated --SR  -->
            <a
              href="https://movementassets-all-web-ue1.s3.amazonaws.com/casey-crawford-media-kit/NewMediaKit.zip">
              Download Media Kit →
            </a>
          </div>
        </div>
      </div>
      <div class="l-press-feature">
        <div
          class="press-feature-photo"
          style="background-image: url('images/social-media-casey2.jpg')" />
        <div class="press-feature-desc">
          <div class="paragraph">
            <p>
              Interested in getting in contact with Casey? Click here to start
              the conversation!
            </p>
          </div>
          <div class="button" on:click={scrollToForm}>
            <span href="">Have Casey Speak →</span>
          </div>
        </div>
      </div>
    </div>

    <div
      class="l-feed"
      bind:offsetWidth={feedWidth}
      bind:offsetHeight={feedHeight}>
      <FacebookFeed {feedWidth} {feedHeight} />
    </div>
  </div>
</section>
